import { render, staticRenderFns } from "./lookup.vue?vue&type=template&id=9a159408&scoped=true&lang=html"
import script from "./lookup.vue?vue&type=script&lang=js"
export * from "./lookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a159408",
  null
  
)

export default component.exports